<template>
  <div class="about">
    <menuBox :step="2"></menuBox>
    <div class="about-box">
      Privacy Policy
    </div>
    <div class="content">
      <h2 style="text-align: center;">Reelbuzz Privacy Policy</h2><br><br>
      Welcome to the privacy policy of Reelbuzz (collectively referred to herein as "Reelbuzz", "we", or "our"). Your
      privacy is important to us. We respect your privacy when processing your personal information.<br>
      This privacy policy ("Privacy Policy") describes our privacy practices, including the types of personal
      information we collect about you, how we use, store, process, disclose your personal information and ensure the
      security of your personal information. Security of your use of our products and services, and your rights in
      relation to our use of that information.<br>
      Please read this Privacy Policy carefully and fully understand the entire content of this Privacy Policy before
      using our services. By using the Platform, you consent to the practices described in this Privacy Policy. If you
      do not agree to your personal information being used in these ways, please stop using the Platform. If you do not
      agree to this policy, please do not register, log in, access or use the Service, and do not share your personal
      data with us.<br>
      If you have any questions or concerns about our use of your personal information, please contact us using the
      contact details provided at the bottom of this Privacy Policy.<br>


      Table of contents:<br>
      I. How we collect and use your personal information<br>
      II. How we share and disclose your personal information<br>
      III. How we store and protect your personal information<br>
      IV. Your Rights and Choices<br>
      V. Protection of minors<br>
      VI. Updates to this policy<br>
      VII. Contact us<br>



      I. How we collect and use your personal information<br>

      Personal information we collect about you<br>
      When you use our services, we will collect and use some of your personal information. The type of information we
      collect and how we use it depend on how you use our services, and we may collect your personal information from
      different sources.<br>

      1. Information you provide to us<br>
      (1) Account information<br>
      We will collect the personal information you provide when registering/logging in, including your mobile phone
      number or email address, password, and birthday. You can also fill in your gender, nickname, avatar and other
      information when registering or during subsequent use. You should ensure the accuracy of such information. We
      collect this information to provide you with account registration and login services, to ensure the security of
      your account and to improve your network profile.<br>

      (2) Exchange information<br>
      When you make text comments on audio, video, and other content, we will collect the text content of the comment
      and related meta-information (such as the sender of the comment, sending time, and IP address). We do this to
      ensure review content is displayed properly and to ensure content security, detect crime, and protect our
      users.<br>

      (3) Picture information<br>
      When you have any comments and feedback on the APP, you can provide corresponding picture information for
      feedback. We will collect the picture information you provide to us to help the APP improve.<br>

      (4) Survey and promotional information<br>
      If you choose to participate in our surveys, promotions, contests or marketing activities, we will collect the
      information you provide, such as your name, contact information, contact address, etc.<br>

      (5) Information provided when contacting us<br>
      When you contact us, for the security of your account and system, we may need you to provide relevant personal
      information to verify your user identity. After successful verification, we will use your contact information
      (phone number/email/other contact information you provide), your communication with us (including
      text/pictures/audio and video), and other necessary information related to your needs. Information to provide you
      with customer service. During this process, we will collect the above personal information you provide in order to
      solve the problems you have raised.<br>

      2. Information we collect automatically<br>
      (1) Equipment information<br>
      We will collect information about the device you use to access our services, including your IP address, device
      type, device model, device name, advertising device identifier, device ID, browser type and settings, operating
      system, language settings, mobile network information (including operator name and phone number), application
      version information, storage information and other technical information to achieve basic product business
      functions and ensure account security.<br>

      (2) Usage information<br>
      When you use the Reelbuzz service, we will collect information about the videos you watch, search terms, number of
      views, etc. We collect this information to provide you with the content you need. We will use this information to
      analyze your video viewing preferences, etc., in order to recommend to you in real time higher-quality video and
      advertising content and services that may be more interesting to you.<br>

      (3) Your location information<br>
      We will collect your location information when you use our services in order to implement some practical
      functions, such as recommending better videos and advertising content in your area. We will use your IP address to
      infer your approximate location.<br>

      (4) Log information<br>
      We will automatically collect log information when you use the Reelbuzz service. We may automatically collect
      comprehensive information about your usage and save it as relevant web logs. This log information includes your
      login account, search query, IP address, browser type, telecommunications provider, network environment, language,
      visit date and time, total page views, push opening records, page dwell time, refresh records, etc. , publishing
      records, following and subscribing records, collections, and sharing.<br>

      Please note that device information and/or log information by itself does not identify a specific individual and
      therefore the information itself is considered non-personal information. However, if such non-personal information
      is combined with other information to identify a specific individual or is combined with other personal
      information, it will be treated as personal information in the process of combination. In this case, it will be
      treated as personal information and protected in accordance with this policy. Unless authorized by you or
      otherwise provided by applicable laws and regulations, such personal information will be anonymized and
      de-identified.<br>

      3. Information from third parties<br>
      (1) Third-party account information<br>
      If you use a third-party platform account (for example: Facebook/Google/Apple ID/Google ID, etc.) to log in to our
      services, we will obtain your account information (including name, avatar, mobile phone number, email address,
      etc.) from the third-party platform. Specifically, Subject to your authorization), we will create or log in to
      your TopShort account, provide services enjoyed by logged-in users, and ensure the security of your account and
      prevent security risks.<br>

      (2) Third-party payment institution information<br>
      If you purchase our VIP services, other paid content, etc., the third-party payment service providers we cooperate
      with (such as Apple pay, Google pay, etc.) will provide us with your payment information or updates to your
      payment information for verification. Your payment status and successfully provide you with purchased services;
      please know that we only collect your purchased product information, payment serial number and channel ID, and do
      not collect any of your bank card account numbers, payment passwords and other payment information.<br>

      (3) Information obtained from public sources<br>
      We may obtain personal information about you from public sources, such as government-published data or publicly
      available data on social media platforms.<br>
      Except as provided above, we will not obtain any of your personal information from any third party without your
      prior authorization. If we need to obtain your personal information from any third party for a business purpose,
      we will ensure that our collection and use are lawful.<br>

      As part of our service we will:<br>
      (1) Take measures as far as possible to ensure that the other party has obtained your consent or shares your
      personal information with us to the extent permitted by relevant laws (including but not limited to entering into
      a contract with the third party, if appropriate);<br>
      (2) Require the other party to commit to ensuring compliance with lawful privacy practices and measures;<br>
      (3) If the method or scope of use exceeds the original authorization, your further consent should be obtained (or
      the other party should be required to obtain) before collecting and using such personal information.<br>
      We will ensure that the same level of security safeguards and measures are in place for any personal information
      we collect, whether collected directly from you or obtained from other parties.<br>


      4. Notifications about specific function permissions<br>
      You acknowledge and agree that we may request certain access permissions on your device to collect and utilize
      information in connection with certain features and services. For example:<br>
      (1) With your consent, allow us to access your storage space to enable you to cache, download and save
      content.<br>

      (2) With your consent, allow us to access your device information and use it as a unique identifier of your device
      to provide you with more personalized recommendations, understand product applicability, identify violations, and
      ensure network and service security.<br>

      (3) Regarding permissions to access album/camera, contact list, microphone, location, calendar (including read and
      write), most mobile devices will allow you to revoke any permissions. For more information, see or contact your
      mobile device's service provider or manufacturer. When you grant us any permission, you authorize us to collect
      and use relevant information to provide you with corresponding services. Once you revoke any permission, your
      authorization will be terminated, and we will no longer continue to collect and use relevant information, nor will
      we provide you with corresponding services. However, the collection and use of information previously authorized
      by you will not be affected.<br>


      Use of personal information<br>
      The information we collect may be used for the following purposes based on different types of information:<br>
      (a) Fulfill agreements and obligations with you;<br>
      (b) Provide, process, maintain, develop and improve Reelbuzz services (including film and television content,
      advertising, paid services purchased by users, etc.);<br>
      (c) Provide personalized recommendation services (including film and television content, advertising);<br>
      (d) process your application (if any) and respond to your questions/inquiries/feedback/disputes;<br>
      (e) Process your registration and login requests, verify and execute transactions related to your online
      payments;<br>
      (f) Allow you to participate in interactive features of the platform (such as audio and video content
      comments);<br>
      (g) Communicate with you, including sending commercial marketing information, operational activity notices,
      agreement update notices, etc. We may use the contact information you provide or collect to contact you and send
      security verification messages, product and service updates, event messages, offers, user experience surveys,
      etc.<br>
      (h) Monitor, prevent or investigate any fraud, abuse, security risks and technical issues that may harm Reelbuzz,
      you or the public, protect the security of your account and system, and improve the security and reliability of
      Reelbuzz services;<br>
      (i) Market research and trend analysis, comprehensive statistics, data analysis, processing, and investigations
      related to TopShort services;<br>
      (j) Other purposes separately disclosed to you when we collect your information, or other purposes for which we
      obtain your consent.<br>

      Cookie Terms<br>
      Cookies are small files containing a string of characters that are sent and stored (usually encrypted) on your
      computer, mobile or other device when you log in to and use a website or other online content. Cookie-like
      technologies are other technologies that can be used for similar purposes to Cookies, such as: Web Beacon, Proxy,
      embedded scripts, etc. In this policy, we collectively refer to them as "cookies."<br>
      Generally speaking, we will use cookies to collect your personal information when you register, log in and use our
      services, such as your website visit habits, your browsing information, your login information, etc.<br>

      We use cookies mainly to simplify operation steps (such as staying logged in, etc.), protect your account
      information and the security of our products, measure and analyze the web pages you click and how you use the
      platform, record your preferences, and provide information to you. You recommend content that you personally need
      and may be more interesting to you, improve website performance, monitor visitor traffic and operations on our
      website, measure, analyze and optimize the advertising performance of our platform, etc. to enhance user product
      experience and improve our services.<br>

      You can manage or delete cookies that have been stored on your computer, mobile device or other devices through
      the relevant functions of your browser or device. Some of our services can only be achieved through the use of
      cookies. If you refuse to use or delete them, you may not be able to use our related services normally or obtain
      the best service experience through our services. Your information may also be compromised. protection and account
      security.<br>


      We will use the personal information collected for the following purposes:<br>
      · To carry out our obligations to you (under any contractual agreement between us or otherwise) and to manage our
      services and your use of our services;<br>
      · Provide software updates, maintenance services and support for our Services;<br>
      · Help you manage your account in connection with our Services, including processing any of your registration and
      login requests, verifying and executing payment-related transactions;<br>
      · Provide you with content that may be of interest to you;<br>
      · Consider and respond to any queries, requests and/or feedback you have (where relevant);<br>
      · Identify, monitor, guard against and prevent any fraud or other legal, security, information or technology risks
      that may affect the security and/or reliability of our services;<br>
      · Conduct market research, data and statistical analysis and processing related to our services to maintain and/or
      improve our services;<br>
      · To comply with all legal and regulatory obligations under all relevant laws and to exercise or defend our
      rights.<br>
      If we intend to use your personal information for any other purpose not covered by this privacy policy, we will
      first obtain your consent.<br>


      II. How we share and disclose your personal information<br>
      1. Share your information yourself<br>
      You may share your personal information or other information with third parties (including unspecified parties)
      through the Reelbuzz service. When you use the sharing function in our services, you can choose to share relevant
      information through email, text messages, social applications (such as Facebook, etc.) or other applications.
      Information you share to third-party applications is controlled by the third party and is subject to its terms of
      service and privacy policy. If information is leaked or used due to your sharing behavior, we have nothing to do
      with it, and you need to bear the corresponding legal responsibilities.<br>

      2. We share your information<br>
      We will not share your information with any third party outside of Reelbuzz without your consent, except in the
      following circumstances:<br>
      (1) Provide you with our services. We may share your information with our partners and third parties to implement
      basic functions or provide services you require, such as payment services, data services.<br>
      (2) Maintain and enhance our services. We may share your information with our partners and third parties to help
      us provide you with more targeted and improved services.<br>
      (3) To achieve the purposes described in "How We Collect and Use Personal Information".<br>
      (4) To perform our obligations and exercise our rights under this Policy or other agreements between you and us.
      (5) Sharing with third parties, including service providers – This includes any payment institutions and other
      service providers (such as Apple, Facebook, Google, Apple Pay and Google Pay).<br>
      (6) Comply with applicable laws and regulations to protect us, our affiliates or partners, you, other users or
      public interests, property or safety from damage, such as preventing fraud and other illegal activities and
      reducing credit risk.<br>
      (7) Assist you to resolve disputes or conflicts with others according to your legal requirements.<br>
      (8) Provide your information at the legal request of you and/or your guardian.<br>
      (9) Provide your information based on academic research.<br>
      (10) Provide your information in accordance with applicable laws and regulations and in the public interest.
      We will only share your information for legal, legitimate, necessary, specific and clear purposes. We will sign
      strict confidentiality agreements with companies, organizations and individuals with whom we share information and
      require them to handle the information in accordance with our instructions, this policy and any other relevant
      confidentiality and security measures.<br>

      3. Disclosure<br>
      We will only disclose your information under the following circumstances, subject to industry standard security
      measures:<br>
      Disclose the information specified by you based on your needs and with your explicit consent;<br>
      When your information is required to be provided in accordance with applicable laws and regulations, mandatory
      administrative enforcement or judicial requirements, we may disclose your information based on the type of
      information requested and the method of disclosure. We will ask the recipient to produce appropriate legal
      documents, such as subpoenas or letters of investigation, and ensure that the requested information is as
      transparent as possible, legally valid, and is limited to data obtained by law enforcement agencies for specific
      legal purposes.<br>

      4. Exceptions to authorization<br>
      According to laws and regulations, we do not need to obtain your authorization to collect, share, and disclose
      your information under the following circumstances:<br>
      (1) Directly related to public security, public health or major public interests;<br>
      (2) Directly related to criminal investigation, prosecution, trial, judgment execution, etc.;<br>
      (3) When it is difficult to obtain your consent in order to protect your or other individuals' life, property and
      other major legitimate rights and interests;<br>
      (4) The information collected is disclosed to the public by you;<br>
      (5) Information collected from legal reports, government information disclosure and other legal disclosure
      channels;<br>
      (6) Fulfill obligations stipulated in laws and regulations;<br>
      (7) Other situations stipulated by laws and regulations.<br>
      Sharing or publicly disclosing personal information that the recipient cannot re-identify as a natural person
      shall not be deemed as sharing or publicly disclosing personal information. We may store and process this data
      without prior notice or consent to you.<br>


      III. How we store and protect your personal information<br>
      1. Storage and retention of your personal information<br>
      We will only retain your information for the period necessary for the purposes stated in this policy and as
      required by applicable laws and regulations. If our services cease to operate, we will notify you via push
      notification or announcement and will delete or anonymize your personal information within any time frame required
      by applicable law or in accordance with our data retention periods.<br>

      2. We adopt certain technical, organizational and physical measures to protect your personal information,
      including security technologies that comply with market standards to support our technical infrastructure and
      systems to minimize unauthorized access, disclosure, and damage. Risks of misuse or alteration of your personal
      information, including:<br>
      (1) Data security technical measures: We will take security protection measures that comply with industry
      standards, including establishing reasonable system specifications and security technologies to prevent your
      information from unauthorized access, modification, loss or damage.<br>
      (2) Other security measures: We manage and regulate the storage and use of information by establishing data
      security rules and conducting comprehensive data security control and awareness through monitoring and auditing
      mechanisms.<br>
      (3) Access by employees and partners: We only allow access to employees and partners who need to know your
      information, and have established strict access control and monitoring mechanisms for this purpose.<br>
      (4) Reasonable precautions: We will take all reasonably feasible measures to ensure that irrelevant information is
      not collected.<br>
      (5) Internet environment: We will try our best to ensure the security of any information you send us, but please
      note that the Internet environment is not 100% secure.<br>
      (6) Security incident handling: We have formulated a system to clarify the classification and grading standards
      and corresponding procedures for security incidents, and established a specialized security incident emergency
      team.<br>
      (7) Your responsibility: Please pay attention to protecting the security of your information, especially the
      security of your account, password and other identity elements.<br>


      IV. Your Rights and Choices<br>
      You have various rights under applicable laws and regulations regarding your personal information in our services,
      and you can choose freely. Your rights and choices may include, but are not limited to:<br>
      (1) Access your personal information<br>
      You have the right to inquire or access your relevant personal information in our services, including by
      contacting us directly or directly within the product.<br>
      (2) Correct/modify your personal information<br>
      You have the right to correct/modify some of your personal information in our services according to the operation
      guidelines and settings provided on the product function page. You can also contact us directly to correct or
      modify your relevant personal information.<br>
      (3) Delete your personal information<br>
      You have the right to delete your relevant personal information in our services, including by contacting us
      directly or deleting it directly within the product. Delete functionality available within our products includes:
      a. Delete usage information: You can delete part of your usage information at any time through the relevant
      product page, for example, delete your viewing history information by clicking "My - Viewing History".<br>
      b. Delete account: You can delete your account by contacting us directly. Once you delete your account, the rights
      and interests you accrue while using our services will no longer apply. All content, information, data and records
      associated with your account will be deleted or anonymized (unless otherwise required by relevant legal or
      regulatory authorities). Cancellation of your account is permanent and irreversible.<br>
      (4) Others<br>
      If you encounter any problems while exercising the above rights, you can contact us through the contact
      information provided in this policy. After verifying your identity, we will provide assistance within a reasonable
      period or within the period specified by the laws of your jurisdiction. You solve the problem, except as otherwise
      provided by laws and regulations or as otherwise agreed in this policy. In addition to the above rights, if the
      laws of your jurisdiction grant you other rights regarding personal information, we will still try our best to
      ensure the realization of your rights.<br>


      V. Protection of minors<br>
      You must be 18 years or older to become a member of our Services.<br>
      We attach great importance to the protection of minors’ personal information. Different jurisdictions have
      different rules regarding the age classification of minors and the protection of minors’ privacy. If you are over
      18 years old but are still considered a minor according to local laws, you should read this Privacy Policy under
      the supervision and guidance of your guardian, and submit relevant personal information after your guardian agrees
      to this Privacy Policy and submits it.<br>
      Please note that due to the nature of the Internet and the anonymity of users online, it is difficult for us to
      identify minors and verify the consent of each guardian. If you are under 18 years old, please obtain the consent
      of your guardian before using our services.<br>
      If a guardian believes that we have collected a minor's personal information without prior consent from the minor,
      we will immediately investigate after receiving the guardian's notification and promptly delete all relevant
      information (if any) as appropriate.<br>


      VI. Updates to this policy<br>
      1. Scope of application of this policy<br>
      Our services may be provided through third-party platforms, or utilize functions operated by third-party
      platforms, or contain or link to websites operated by third parties. The information processing rules of such
      third parties are determined by them and may be different from ours. Third-party websites, applications,
      platforms, etc. have independent privacy policies, and this policy does not apply. Therefore, we recommend that
      you read its privacy policy carefully and carefully. For example: When a link to a website operated by a third
      party appears within our App, we will notify you or mark it as "Third Party Products", "Third Party Services" or
      similar expressions.<br>

      2. Updates to this policy<br>
      Based on the continuous innovation and development of Reelbuzz's business model and technical functions, we may
      update the terms of this "Reelbuzz Privacy Policy" from time to time and provide notifications in accordance with
      applicable laws and regulations, which may include publishing notifications, push messages, pop-ups, emails, etc.
      or There are multiple ways for you to review the updated privacy policy before choosing to continue using our
      services, and decide whether to continue using our services accordingly. If such updates involve us collecting
      more personal information from you, or if the purpose or method of using/sharing personal information or the third
      party receiving the information changes, we will obtain your authorization and consent again. We recommend that
      you review this Policy each time you use our Services.<br>


      VII. Contact us<br>
      If you encounter matters related to privacy protection when using our services or have any questions about this
      policy (including inquiries, complaints, suggestions, etc.), you can submit feedback online or contact us through
      the following contact information :<br>
      (1) Send email to: services@reelbuzztv.com<br>
      (2) Other contact methods provided by Reelbuzz. We will reply to you as soon as possible after receiving your
      comments and suggestions.<br>

    </div>
    <footerBox :step="2"></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      val: ''
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "Services" });
    },
  },
};
</script>
<style lang="less" scoped>
.about-box {
  position: relative;
  top: -100px;
  background-image: url(../assets/Privacy.png);
  width: 100%;
  height: 300px;
  background-size: 100% 100%;
  padding: 130px 360px 0 360px;
  font-family: Poppins, Poppins;
  font-weight: bold;
  font-size: 52px;
  color: #FFFFFF;
  line-height: 61px;
  text-align: center;
  box-sizing: border-box;
}

.content {
  padding: 0 360px 200px;
  color: #4E4E4E;
  font-style: 20px;
}
</style>
